import { useTranslation } from 'react-i18next';

import type { DraftOrderBlocker } from '@nucleus-commerce/api-client/admin';
import { cn } from '@nucleus-commerce/ui/lib/utils';

/** What still stops invoicing or completion, in plain words. */
export function BlockerList({
  blockers,
  className,
}: {
  blockers: readonly DraftOrderBlocker[];
  className?: string;
}) {
  const { t } = useTranslation('draftOrders');
  return (
    <ul
      className={cn('list-disc space-y-1 pl-4 text-sm', className)}
      aria-label={t('blockers.title')}
    >
      {blockers.map((blocker) => (
        <li key={blocker}>{t(`blockers.${blocker}`)}</li>
      ))}
    </ul>
  );
}
